module.exports = __webpack_public_path__ + "img/logo-dark.a96c6a87.svg";